// extracted by mini-css-extract-plugin
export default {"swiper":"SwiperDemo_swiper__choy1","swiperSlide":"SwiperDemo_swiperSlide__3zFt0"};